define((require) => {
    "use strict";

    const $                                 = require("jquery");
    const {bindAll}                         = require("underscore");
    const formatResultTemplate              = require("ui/experience/widgets/socialSharingWidget/SocialSharingWidgetFormatResult.tpl");
    const formatSelectionTemplate           = require("ui/experience/widgets/socialSharingWidget/SocialSharingWidgetFormatSelection.tpl");
    const SocialSharingWidgetViewController = require("ui/experience/widgets/socialSharingWidget/SocialSharingWidgetViewController");
    const SocialSharingWidgetView           = require("shared/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetView");
    const {ACTUAL_NETWORKS}                    = require("shared/xp/components/widgets/socialsharing/SocialSharingService");
    const KeyCode                           = require("shared/services/KeyCode");

    const CONTAINER_WIDTH = 205;

    /**
     * The Mixin rendering a social sharing widget when in the Editor.
     *
     * @class SocialSharingWidgetView
     *
     * @cfg {SocialSharingWidgetModel} model The model of the social sharing icon being rendered.
     */
    return SocialSharingWidgetView.mixin({

        _containerShare: null,

        controller: SocialSharingWidgetViewController,

        events: {
            "change": "_changeEditorSelectionHandler",
            "dragstart": "_dragStartHandler"
        },

        initialize() {
            bindAll(this, "_keyUpHandler", "_select2OpenHandler");
        },

        updateRendering(element, bounds, active, edited) {
            if (!edited) {
                // For preview we want to call the Viewer logic
                return this.__super();
            }

            element.empty();

            element.append(this._buildDropdown());
        },

        _changeEditorSelectionHandler(event) {
            this.trigger("changeEditorSelect", event);
        },

        /**
         *  This is needed because otherwise social icons images would be draggable in the Editor.
         * @returns {boolean}
         * @private
         */
        _dragStartHandler() {
            return false;
        },

        /**
         * Builds the Select2 dropdown for the Editor.
         * @returns {JQuery} JQuery object containing select2 container
         * @private
         */
        _buildDropdown() {
            const networksModel = this.model.get("networks");
            const networks = networksModel.join();
            const containerWidth = networksModel.length < 5 ? CONTAINER_WIDTH - 38 : CONTAINER_WIDTH;

            const $input = $("<input>", {
                type: "hidden",
                "class": "select2-field",
                value: networks
            });
            const $containerShare =  $("<div>", {
                "class": "container-share",
                html: $input
            });

            $input.select2({
                width: containerWidth,
                tags: ACTUAL_NETWORKS,

                // Prevents inserting characters in the select component.
                maximumInputLength: 0,

                formatResult: (state) => {
                    return formatResultTemplate({
                        style: this.model.get("style"),
                        state: state
                    });
                },

                formatSelection: (state) => {
                    return formatSelectionTemplate({
                        style: this.model.get("style"),
                        state: state
                    });
                },

                // Prevents on creating new tags.
                createSearchChoice: () => {
                    return null;
                }
            });

            // Handles the deletion of the widget, including when the drop-down in the Editor is open.
            $containerShare.on("keyup", this._keyUpHandler);

            // Removes the search field when all networks have already been selected
            $containerShare.on("select2-open", this._select2OpenHandler);

            this._containerShare = $containerShare;

            return $containerShare;
        },

        onClose() {
            if (this._containerShare) {
                this._containerShare.off("keyup", this._keyUpHandler);
                this._containerShare.off("select2-open", this._select2OpenHandler);
            }
        },

        _keyUpHandler(event) {
            if (event.keyCode === KeyCode.DELETE || event.keyCode === KeyCode.BACK_SPACE) {
                const $mask = $("#select2-drop-mask");

                if ($mask.length) {
                    $mask.trigger("click");
                }
            }
        },

        _select2OpenHandler() {
            const $drop = $(".select2-drop");
            const unselectedItems = $drop.find("li:not(.select2-selected)");

            if ($drop.length) {
                const currentLayerAndSceneWidgets = this.options.viewModel.get("activeLayerSceneModel");

                const isInActiveSceneAndLayer = Boolean(currentLayerAndSceneWidgets.get(this.model));

                const socialWidgetHasAllIconsSelectedAlready = !unselectedItems.length;
                const shouldNotShowDropdown = socialWidgetHasAllIconsSelectedAlready || !isInActiveSceneAndLayer;
                if (shouldNotShowDropdown) {
                    $drop.hide();
                    $(".select2-search-field").hide();
                }
            }
        },

        /**
         * This method is extends and changes the highlight
         * of the widget astract method `_updateHightlight`
         */
        applyWidgetSpecificHighlight() {
            // Highlight widget if required
            if (this.model.get("highlighted")) {
                this.$el.css({
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "inset 0px 0px 0px 3px #8c01ff"
                });
            } else if (!this.model.get("boxShadow")) {
                this.$el.css({
                    boxShadow: "inset 0px 0px 0px 0px transparent"
                });
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetViewEditorMixin.js